









import { defineComponent } from "@vue/composition-api";
import { Transaction, TransactionsSearchResult } from "@scrile/api-provider/dist/api/TransactionProvider";
import useAuthUser from "@/hooks/useAuthUser";
import useBalance from "@/hooks/useBalance";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import BalanceView from "./components/BalanceView.vue";

export default defineComponent({
  name: "PageBalance",
  components: { BalanceView },
  setup() {
    const { getBalance, balance } = useBalance();
    const { authUserStrict } = useAuthUser();
    return { getBalance, balance, authUserStrict };
  },
  data() {
    return {
      loading: false,
      enableScroll: false,
      transactionsSearchResult: null as TransactionsSearchResult | null,
    };
  },
  computed: {
    transactionsList(): Transaction[] {
      return this.transactionsSearchResult?.result ?? [];
    },
  },
  methods: {
    async getTransactions(page: number = 0, replace: boolean = true) {
      try {
        this.enableScroll = false;
        const data = await providers.TransactionProvider.find({
          data: { userId: this.authUserStrict.id, hidden: false, page, sort: "TIME,DESC" },
        });
        if (!replace && this.transactionsSearchResult) {
          data.result = [...this.transactionsSearchResult.result, ...data.result];
        }
        this.transactionsSearchResult = data;
      } finally {
        this.enableScroll = this.transactionsSearchResult?.hasNextPage ?? false;
      }
    },
    getNextData(cb?: Function) {
      const page = (this.transactionsSearchResult?.page ?? 0) + 1;
      this.getTransactions(page, false).finally(() => cb && cb());
    },
    handlePurchase(transaction?: Transaction) {
      if (!this.transactionsSearchResult || !transaction) {
        return;
      }
      const result = Array.from(this.transactionsSearchResult.result);
      result.unshift(transaction);
      if (this.transactionsSearchResult.hasNextPage) {
        result.pop();
      }
      this.$set(this.transactionsSearchResult, "result", result);
    },
  },
  async created() {
    emitter.on<Transaction>(EVENTS.BALANCE_REFILL_PURCHASED, this.handlePurchase);
    try {
      this.loading = true;
      await Promise.all([this.getTransactions(), this.getBalance()]);
    } finally {
      this.loading = false;
    }
  },
  beforeDestroy() {
    emitter.off<Transaction>(EVENTS.BALANCE_REFILL_PURCHASED, this.handlePurchase);
  },
});
